/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocations_Edit_TitleInputs */

const en_admin_allocations_edit_title = /** @type {(inputs: Admin_Allocations_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Allocation`)
};

const de_admin_allocations_edit_title = /** @type {(inputs: Admin_Allocations_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuweisung bearbeiten`)
};

const es_admin_allocations_edit_title = /** @type {(inputs: Admin_Allocations_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar asignación`)
};

const fr_admin_allocations_edit_title = /** @type {(inputs: Admin_Allocations_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier l'attribution`)
};

/** @type {(inputs: Admin_Allocations_Edit_TitleInputs) => LocalizedString} */
const it_admin_allocations_edit_title = en_admin_allocations_edit_title;

/** @type {(inputs: Admin_Allocations_Edit_TitleInputs) => LocalizedString} */
const pt_br2_admin_allocations_edit_title = en_admin_allocations_edit_title;

/** @type {(inputs: Admin_Allocations_Edit_TitleInputs) => LocalizedString} */
const pl_admin_allocations_edit_title = en_admin_allocations_edit_title;

/** @type {(inputs: Admin_Allocations_Edit_TitleInputs) => LocalizedString} */
const hu_admin_allocations_edit_title = en_admin_allocations_edit_title;

/** @type {(inputs: Admin_Allocations_Edit_TitleInputs) => LocalizedString} */
const ro_admin_allocations_edit_title = en_admin_allocations_edit_title;

/**
* | output |
* | --- |
* | "Edit Allocation" |
*
* @param {Admin_Allocations_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocations_edit_title = /** @type {((inputs?: Admin_Allocations_Edit_TitleInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocations_Edit_TitleInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocations_edit_title(inputs)
	if (locale === "de") return de_admin_allocations_edit_title(inputs)
	if (locale === "es") return es_admin_allocations_edit_title(inputs)
	if (locale === "fr") return fr_admin_allocations_edit_title(inputs)
	if (locale === "it") return it_admin_allocations_edit_title(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocations_edit_title(inputs)
	if (locale === "pl") return pl_admin_allocations_edit_title(inputs)
	if (locale === "hu") return hu_admin_allocations_edit_title(inputs)
	return ro_admin_allocations_edit_title(inputs)
});
export { admin_allocations_edit_title as "admin.allocations.edit_title" }